import github from './logos/github.svg'
import linkedin from './logos/linkedin.svg'

export default {
  linkedin,
  github,
}

